import {
  DepositDetailWrapper,
  DepositTextWrapper,
  WalletAddressContainer,
} from "components/Deposit/styled";

import { Box, Drawer, MenuItem, Typography } from "@mui/material";
import { CircleButton } from "components/CircleButton";
import { StyledDepositDrawer } from "components/Deposit/styled";
import { Close } from "@mui/icons-material";
import { RetroButton } from "components/RetroButton";
import { Chain } from "chainConfigs";
import {
  CrossChainConfig,
  crossChainConfigs,
} from "v2/components/CrossChainDeposit/hocs/withCrossChainDeposit";
import { Col, Row } from "v2/components/base/Flex/ui";
import Select from "v2/components/base/Select/ui";
import theme from "theme";
import BasicButton from "v2/components/Buttons/BasicButton";
import CloseButton from "v2/components/Buttons/CloseButton";

const CrossChainDeposit = ({
  defaultChain,
  chains,
  isOpen,
  close,
  onCopySuccess,
  sortedConfigs,
  supporttedChainList,
  handleCopy,
  selectedChain,
  setSelectedChain,
  walletAddresses,
}: {
  defaultChain: Chain;
  chains: Chain[];
  isOpen: boolean;
  close: () => void;
  onCopySuccess: () => void;
  sortedConfigs: CrossChainConfig[];
  supporttedChainList: string[];
  handleCopy: () => void;
  selectedChain: Chain;
  setSelectedChain: (chain: Chain) => void;
  walletAddresses: Record<string, string>;
}) => {
  return (
    // <StyledDepositDrawer anchor={"bottom"} open={isOpen} onClose={close}>
    <Drawer
      anchor={"bottom"}
      open={isOpen}
      sx={{
        "& .MuiDrawer-paper": {
          width: "100%",
          height: "100%",
          backgroundColor: theme.palette.surface.black,
          // background: "url('/search-bg.png') no-repeat center center",
          // backgroundSize: "contain",
          color: theme.palette.text.primary,
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          padding: "24px",
        },
      }}>
      <Col type="cc" sx={{ maxWidth: "1200px" }} fullWidth fullHeight>
        <Box
          sx={{
            marginLeft: "auto",
            fontSize: "16px",
            cursor: "pointer",
          }}>
          <CloseButton variant="white" onClick={close} />
        </Box>
        <DepositDetailWrapper>
          <Row
            type="cc"
            sx={{
              maxWidth: "495px",
              textAlign: "center",
              marginBottom: "16px",
            }}
            fullWidth>
            <Typography variant="mobile-h1">Deposit to your wallet</Typography>
          </Row>
          <DepositTextWrapper>
            <Typography variant="mobile-body-s" color="text.secondary">
              Deposit {supporttedChainList.join(", ")} to start trading.
            </Typography>
          </DepositTextWrapper>
          <Select
            value={selectedChain}
            onChange={(event: any) => setSelectedChain(event.target.value as Chain)}
            sx={{ width: "100%", maxWidth: "495px", marginBottom: "24px" }}
            options={sortedConfigs.map((option) => ({
              label: option.networkName,
              value: option.id,
            }))}
          />
          <WalletAddressContainer>
            <Typography variant="body-md" color="text.primary">
              {walletAddresses
                ? walletAddresses[crossChainConfigs[selectedChain].walletName]
                : "Loading..."}
            </Typography>
          </WalletAddressContainer>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              maxWidth: "495px",
            }}>
            <BasicButton variant="primary" sx={{ width: "100%" }} onClick={handleCopy}>
              <Typography variant="mobile-body-s-heavy">Copy Address</Typography>
            </BasicButton>
          </Box>
        </DepositDetailWrapper>
      </Col>
    </Drawer>
  );
};

export default CrossChainDeposit;
